module.exports = __webpack_public_path__ + "static/media/previous-arrow.4ec90b57.svg";